/**
 * PromotionRegisterPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable, Table } from 'components';
import { Select, Input, Button, DatePicker, Radio, Avatar } from 'antd';
import { stringToMoneyFormat } from 'utils';
import { PictureOutlined } from '@ant-design/icons';

const PromotionRegisterPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const hours = [];
  const minute = [];
  for (let i = 0; i < 24; i++) {
    hours.push({ label: `${i.toString().length > 1 ? i : `0${i}`}`, value: i });
  }
  for (let i = 0; i < 60; i += 10) {
    minute.push({
      label: `${i.toString().length > 1 ? i : `0${i}`}`,
      value: i,
    });
  }
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '프로모션명',
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="프로모션명 입력"
              style={{ ...styles.form.input.large, width: 400 }}
            />
          ),
          count: true,
          maxLength: 250,
        },
      ],
    },
    {
      label: '프로모션 설명',
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="프로모션 설명 입력"
              style={{ ...styles.form.input.large, width: 400 }}
            />
          ),
          count: true,
          maxLength: 250,
        },
      ],
    },
    {
      label: '프로모션 설명',
      form: [
        {
          input: (
            <DatePicker
              size="large"
              format={'YYYY-MM-DD'}
              placeholder=""
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <>
              <Select
                size="large"
                value={hours[0].value}
                options={hours}
                placeholder=""
                style={{ ...styles.form.input.medium }}
              />
              <p>시</p>
            </>
          ),
        },
        {
          input: (
            <>
              <Select
                size="large"
                value={minute[0].value}
                options={minute}
                placeholder=""
                style={{ ...styles.form.input.medium }}
              />
              <p>분</p>
              <p>~</p>
            </>
          ),
        },
        {
          input: (
            <DatePicker
              size="large"
              format={'YYYY-MM-DD'}
              placeholder=""
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <>
              <Select
                size="large"
                value={hours[0].value}
                options={hours}
                placeholder=""
                style={{ ...styles.form.input.medium }}
              />
              <p>시</p>
            </>
          ),
        },
        {
          input: (
            <>
              <Select
                size="large"
                value={minute[0].value}
                options={minute}
                placeholder=""
                style={{ ...styles.form.input.medium }}
              />
              <p>분</p>
            </>
          ),
        },
      ],
    },
    {
      label: '노출여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'노출함'}>
                <Radio value={'노출함'}>노출함</Radio>
                <Radio value={'노출안함'}>노출안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '최소 수량',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
              />
              <p>장</p>
            </>
          ),
        },
      ],
    },
    {
      label: '진행여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'진행함'}>
                <Radio value={'진행함'}>진행함</Radio>
                <Radio value={'진행안함'}>진행안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];
  const form2 = [
    {
      label: '할인 설정',
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.medium }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              placeholder="%"
              style={{ ...styles.form.input.medium, width: 80 }}
            />
          ),
        },
        {
          input: (
            <>
              <p>최대</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
              />
              <p>원 할인</p>
            </>
          ),
        },
      ],
    },
    {
      label: '적립 설정',
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.medium }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              placeholder="%"
              style={{ ...styles.form.input.medium, width: 80 }}
            />
          ),
        },
      ],
    },
    {
      label: '적립 설정',
      form: [
        {
          input: (
            <Select
              size="large"
              placeholder="%"
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: <Button size="large">쿠폰 불러오기</Button>,
        },
      ],
    },
    {
      label: '포인트 사용여부 설정',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'사용'}>
                <Radio value={'사용'}>사용</Radio>
                <Radio value={'미사용'}>미사용</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];
  const form3 = [
    {
      label: '할인 대상',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체상품'}>
                <Radio value={'전체상품'}>전체상품</Radio>
                <Radio value={'브랜드'}>브랜드</Radio>
                <Radio value={'카테고리'}>카테고리</Radio>
                <Radio value={'개별상품'}>개별상품</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 6; i++) {
    newData.push({
      no: i + 1,
      상품구분: '기본상품',
      상품코드: `0000000`,
      img: <Avatar size={50} shape="square" icon={<PictureOutlined />} />,
      name: '[과테말라] 디카페인 200g',
      price: 20000,
      sale: 500,
      m_sale: 1000,
      url: `URL`,
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>회원 등록</Title>

          {/* 기본정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>기본 정보</Title>
            <InputFormTable form={form1} />
          </Content>
          {/* 기본정보 끝 */}

          {/* 혜택 설정 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>혜택 설정</Title>
            <InputFormTable form={form2} />
          </Content>
          {/* 혜택 설정 */}

          {/* 대상 설정 */}
          <Content maxWidth={'100%'} padding={20} borderRadius={4}>
            <Title style={{ ...styles.subTitle }}>대상설정</Title>
            <InputFormTable form={form3} />

            {/* 적용상품 테이블 */}
            <div style={{ marginTop: 14 }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <h4
                    style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                  >
                    총 <span>0</span>건
                  </h4>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    복사
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    삭제
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    분류수정
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    메인진열수정
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    엑셀다운로드
                  </Button>
                </div>
                <div>
                  <Select
                    size="large"
                    value={'등록일순'}
                    options={[
                      { label: '등록일순', value: '등록일순' },
                      { label: '등록일순2', value: '등록일순2' },
                    ]}
                    style={{ ...styles.form.input.large }}
                  />
                </div>
              </div>
              <Table
                data={newData}
                isChecked
                columns={[
                  {
                    title: 'No',
                    key: 'no',
                  },
                  {
                    title: '상품구분',
                    key: '상품구분',
                  },
                  {
                    title: '상품코드',
                    key: '상품코드',
                  },
                  {
                    title: '상품 이미지',
                    key: 'img',
                  },
                  {
                    title: '상품명',
                    key: 'name',
                  },
                  {
                    title: '판매가',
                    key: 'price',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '할인가',
                    key: 'sale',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '모바일 할인가',
                    key: 'm_sale',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: 'URL',
                    key: 'url',
                  },
                ]}
              />
            </div>
            {/* 적용상품 테이블 끝 */}
          </Content>
          {/* 대상 설정 끝 */}

          {/* 저장/취소 버튼 */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              marginTop: 20,
            }}
          >
            <Button
              size="large"
              type="primary"
              style={{ ...styles.button, background: 'var(--primary-color)' }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              취소
            </Button>
          </div>
          {/* 저장/취소 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default PromotionRegisterPresenter;
